import { HTTP_STATUS_CODES } from '../../../constants/httpStatusCodes';

const ForbiddenErrorContent = () => {
  return (
    <>
      <div className='font-bold text-[38px] text-center'>You don&apos;t have access to view campaigns</div>
    </>
  );
};

export default {
  [HTTP_STATUS_CODES.FORBIDDEN]: ForbiddenErrorContent,
};
